module.exports = __webpack_public_path__ + "static/media/avatar.fb84ab08.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/avatar.jpg
// module id = 308
// module chunks = 0